// extracted by mini-css-extract-plugin
module.exports = {"ErrorText":"ErrorText_ErrorText__pi3Sn"};